import {
  Box,
  Image,
  Text,
  Heading,
  Stack,
  Container,
} from "@chakra-ui/react";

import Navbar from "./Navbar";
import { useAuth } from './AuthContext';

import HeroImage from "./images/stamps.png";

const ClientImplementations = () => {
  const { user } = useAuth();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      {!user ? (
        <Container maxW="container.md" py={20}>
          <Box
            bg="white"
            p={6}
            borderRadius="md"
            boxShadow="md"
            textAlign="center"
          >
            <Text fontSize="md">
              You must be logged in to view this content.
            </Text>
          </Box>
        </Container>
      ) : (
        <Container maxW="container.xl" py={8}>
          <Stack spacing={6}>
            {/* Header */}
            <Box
              bg="rgba(255,255,255,0.95)"
              p={6}
              borderRadius="lg"
              boxShadow="xl"
              textAlign="center"
            >
              <Heading
                fontSize="3xl"
                mb={2}
                color="gray.800"
                fontWeight="bold"
              >
                Client Implementations
              </Heading>
              <Text fontSize="md" color="gray.600">
                Client-specific configurations and deployment settings
              </Text>
            </Box>

            {/* Placeholder Content */}
            <Box
              bg="rgba(255, 255, 255, 0.9)"
              p={8}
              borderRadius="md"
              boxShadow="md"
              border="1px solid #3182ce"
              textAlign="center"
            >
              <Text fontSize="lg" color="gray.600">
                Client implementation pages coming soon...
              </Text>
              <Text fontSize="sm" color="gray.500" mt={2}>
                This section will contain client-specific deployment configurations,
                custom integrations, and implementation documentation.
              </Text>
            </Box>
          </Stack>
        </Container>
      )}
    </Box>
  );
};

export default ClientImplementations;
